import { render } from "./MyTemplates.vue?vue&type=template&id=c00d00c0"
import script from "./MyTemplates.vue?vue&type=script&lang=ts"
export * from "./MyTemplates.vue?vue&type=script&lang=ts"
script.render = render

export default script